import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/save-pre-check-consent-progress`, data)

    return result.data
}

export default service
